/**
 * LanguageSwitcher — visible in the AppBar. Swaps the i18next language and
 * (in the future) PATCHes /api/account/locale to persist for the user.
 * For Phase 0 we don't call the account endpoint yet — that's a Phase 7
 * polish item once that surface is exercised.
 */
import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  SUPPORTED_LOCALES,
  isSupportedLocale,
  normalizeLocale,
  type SupportedLocale,
} from '@/i18n/constants';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current: SupportedLocale =
    normalizeLocale(i18n.language) ?? (isSupportedLocale(i18n.language) ? i18n.language : 'en');

  return (
    <TextField
      select
      size="small"
      variant="standard"
      value={current}
      onChange={(e) => {
        const raw = e.target.value;
        if (isSupportedLocale(raw)) {
          void i18n.changeLanguage(raw);
          if (typeof document !== 'undefined') {
            document.documentElement.lang = raw;
          }
        }
      }}
      slotProps={{ htmlInput: { 'aria-label': t('language_switcher.label') } }}
      sx={{ minWidth: 120 }}
    >
      {SUPPORTED_LOCALES.map((locale) => (
        <MenuItem key={locale} value={locale}>
          {t(`language_switcher.options.${locale}`)}
        </MenuItem>
      ))}
    </TextField>
  );
}
